import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 6l2 -2v3a7 7 0 0 0 14 0v-3l2 2","key":"svg-0"}],["path",{"d":"M12 21v-18l-2 2m4 0l-2 -2","key":"svg-1"}]]

/**
 * IconTrident
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItdHJpZGVudCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMyA2bDIgLTJ2M2E3IDcgMCAwIDAgMTQgMHYtM2wyIDIiIC8+CiAgPHBhdGggZD0iTTEyIDIxdi0xOGwtMiAybTQgMGwtMiAtMiIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/trident
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconTrident = createReactComponent('outline', 'trident', 'Trident', __iconNode);

export default IconTrident;